export const limits = {
	0: '私有',
	1: '公有'
}

export const musical = [
	{ val: 'easy', name: '简谱' },
	{ val: 'big', name: '大谱表' },
	{ val: 'treble', name: '高音谱表' },
	{ val: 'bass', name: '低音谱表' },
	{ val: 'four', name: '合唱四声部' }
]

export const audioTypes = {
	1: {
		ORDIDX: '1',
		NAME: '音频',
		CODE: 'VOICE1'
	},
	2: {
		ORDIDX: '2',
		NAME: '男高音',
		CODE: 'VOICE2'
	},
	3: {
		ORDIDX: '3',
		NAME: '男中音',
		CODE: 'VOICE3'
	},
	4: {
		ORDIDX: '4',
		NAME: '男低音',
		CODE: 'VOICE4'
	},
	5: {
		ORDIDX: '5',
		NAME: '女高音',
		CODE: 'VOICE5'
	},
	6: {
		ORDIDX: '6',
		NAME: '女中音',
		CODE: 'VOICE6'
	},
	7: {
		ORDIDX: '7',
		NAME: '女低音',
		CODE: 'VOICE7'
	},
	8: {
		ORDIDX: '8',
		NAME: '伴唱',
		CODE: 'BANCHANG'
	},
	9: {
		ORDIDX: '9',
		NAME: '范唱',
		CODE: 'FANCHANG'
	},
  10: {
    ORDIDX: '10',
    NAME: '演唱题-伴唱',
    CODE: 'SING_BANCHANG'
  }
}

export const adminIdentity = [
	{ name: '平台', id: 1 },
	{ name: '教师', id: 3 }
]
export const teacherIdentity = [
	{ name: '自有', id: 5 },
	{ name: '校方', id: 4 },
	{ name: '平台', id: 1 }
]
export const schoolIdentity = [
	{ name: '校方', id: 4 },
	{ name: '平台', id: 1 }
]
